export enum SnippetInputType {
    TEXT = 'text',
    TEXTAREA = 'textarea',
    DROPDOWN = 'dropdown',
    DATE = 'date',
    CHECKBOX = 'checkbox',
    DISPLAY_CHECKBOX = 'displaycheckbox',
    SEQ_NUM = 'seqnum',
    TABLE = 'table',
    SCD_SEARCH = 'scd',
    OFFER_NUM = 'custom',
    LOGO_IMAGE = 'logoImage'
}

export function GetSnippetTypeFromAlias(type: string): SnippetInputType {
    if (!type) {
        return null;
    }

    const retval =
        SnippetInputType[Object.keys(SnippetInputType).find((typeOption) => SnippetInputType[typeOption] === type)];
    if (retval) {
        return retval;
    }

    // aliases
    switch (type) {
        case 'dd':
            return SnippetInputType.DROPDOWN;
        case 'cb':
            return SnippetInputType.CHECKBOX;
        case 'dcb':
        case 'dcheckbox':
            return SnippetInputType.DISPLAY_CHECKBOX;
        case 'li':
            return SnippetInputType.LOGO_IMAGE;
    }

    return null;
}
